import React, {useEffect, useState} from "react";
import * as echarts from "echarts";
import DevelopmentRequestController from "../../../../stories/_ticket/DevelopmentRequests/DevelopmentRequestController";
import "../../../../css/page/contents/client/Fragmentation.css";

const FragmentationDevReq = () => {
	const [ fragmentation, setFragmentation ] = useState(null);

	const getFragmentation = () => {
		const controller = new DevelopmentRequestController();
		controller._callback = returnGetFragmentation;
		controller.fragmentation();
	}
    const returnGetFragmentation = (result, error, status) => {
        switch (status) {
            case 200:
				setFragmentation(result.data);
                break;
            default:
                break;
        }
    }
	const buildFragmentation = () => {
		return <div className={"fragmentation"}>
			<h1 className={"title"}>Répartition des demandes</h1>
			<div id={"chart"} className={"chart"} />
		</div>;
	}
	const buildChartOption = () => {
		if (fragmentation === null) return;

		let chartDom = document.getElementById('chart');
		let myChart = echarts.init(chartDom);
		let option;
		let datas = [];

		for (let i in fragmentation) {
			datas.push({
				value: parseInt(fragmentation[i].total),
				name: DevelopmentRequestController._states[fragmentation[i].state]
			})
		}

		option = {
			tooltip: {
				trigger: 'item'
			},
			legend: {
				show: false
			},
			top: '-20%',
			width: 'auto',
			height: 400,
			radius: "90%",
			series: [
				{
					name: 'Etats des demandes',
					type: 'pie',
					radius: ['40%', '70%'],
					//center: ['50%', '70%'],
					itemStyle: {
						borderRadius: 5,
						borderColor: '#fff',
						borderWidth: 2
					},
					emphasis: {
						label: {
							show: true,
							fontWeight: 'bold'
						}
					},
					startAngle: 180,
					endAngle: 360,
					data: datas
				}
			]
		};

		option && myChart.setOption(option);
	}

	useEffect(() => {
		getFragmentation();
	}, []);
	useEffect(() => {
		buildChartOption();
	}, [fragmentation]);

    return buildFragmentation();
}

export default FragmentationDevReq;